import cx from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import * as styles from './Image.module.css';

const Image = ({
	image,
	alt = '',
	fit = 'cover',
	position = 'center',
	className = '',
	overflow,
	onClick,
	center,
}: {
	image: any;
	alt: string | undefined;
	fit?: string | undefined;
	position?: 'top' | 'center' | 'bottom';
	className?: string;
	overflow?: boolean;
	onClick?: any;
	center?: boolean;
}): JSX.Element => {
	return (
		<GatsbyImage
			image={image}
			alt={alt}
			objectFit={fit}
			objectPosition={position}
			onClick={onClick}
			className={cx({
				[styles.overflow]: overflow,
				[className]: !!className,
				[styles.center]: center,
			})}
		/>
	);
};

export default Image;
